<template>
  <div class="share">
    <van-nav-bar :title="$t('mine.recharge')" class="nav-bar"
                 style="background: linear-gradient(135deg, rgb(224, 170, 255) 0%, rgb(166, 178, 252) 100%)">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>

      <template #right>
        <router-link to="/RechargeRecord" style="font-size: 14px">{{ $t("充值历史") }}</router-link>
      </template>
    </van-nav-bar>
    <div class="center">
      <div style="background-color: rgb(54, 146, 249); padding: 15px; border-radius: 15px;"><h1
          style="margin-top: 20px; color: rgb(255, 255, 255);">{{ $t("可用余额") }}:</h1>
        <div style="color: rgb(255, 255, 255); font-weight: bold; line-height: 40px;">{{ $store.getters.getBaseInfo.currency }}
          {{ data.money*1 }}</div>
      </div>
      <div class="ipt">
        <h1 style="padding: 15px 0px;">{{ $t("personalreport.recharge") }}:</h1>
        <input type="number" v-model="money" :placeholder="$t('请输入充值金额')"></div>
      <div class="select-money">
        <div class="money-item" v-for="(item,key) in data.recharge_amount" :key="key" @click="money = item">
          {{ formatNumber(item) }}
        </div>
      </div>

      <van-button class="login-btn" type="primary" size="normal" @click="doRecharge()">{{ $t("mine.recharge") }}</van-button>
<!--      <button type="button" class="van-button van-button&#45;&#45;primary van-button&#45;&#45;normal van-button&#45;&#45;block"
              style="color: white; background: rgb(54, 146, 249); border-color: rgb(54, 146, 249);">
        <div class="van-button__content"><span class="van-button__text">충전</span></div>
      </button>-->
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      data: [],
      money: ""
    };
  },
  methods: {

    doRecharge() {
      if (this.money < 0 || this.money == '') {

        this.$toast(this.$t("请输入充值金额"));
        return false;
      }
      this.$http({
        method: 'get',
        url: 'money_recharge',
        data: {money: this.money}
      }).then(res => {
        if (res.code === 200) {
          this.money = "";
          this.$toast.success(this.$t("提交成功"));
          this.service();
        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        }
      })
    },

    copyText(t) {
      navigator.clipboard.writeText(t);
      this.$toast.success(this.$t("复制成功"));
    },

    //客服
    service() {
      window.location.href = this.$store.getters.getBaseInfo.kefu;
    },

    back() {
      return window.history.back();
    },

    getRechargePei() {
      this.$http({
        method: 'get',
        url: 'recharge_info'
      }).then(res => {
        if (res.code === 200) {
          this.data = res.data;
        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        }
      })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'})
    } else {
      this.getRechargePei();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.share {
  width: 100%;
  height: 100%;
  background: #fffeef
}

.share .select-money {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: .66667rem
}

.share .select-money .money-item {
  width: 30%;
  text-align: center;
  padding: .46667rem .66667rem;
  background-color: #3692f9;
  border-radius: .66667rem;
  color: #fff
}

.share .van-field__value {
  background: #f4f4f5;
  border: 1px solid #c8c9cc;
  padding: 6px 20px
}

.share .center {
  width: 96%;
  margin: 1rem auto;
  text-align: left;
  padding: .66667rem
}

.share .center h1 {
  font-size: 1.06667rem
}

.share .center p {
  font-size: .76667rem;
  color: #333;
  padding: .26667rem 0
}

.share .center .ipt {
  background: #fff;
  margin: 1rem auto;
  padding: 1rem;
  border-radius: .66667rem
}

.share .center .ipt p {
  color: #333;
  font-size: .9rem;
  padding: 1rem 0
}

.share .center .ipt input {
  width: 100%;
  border: none;
  padding: .66667rem 1rem;
  border-radius: 3.33333rem;
  background: #f5f5f5
}

.share .van-button--block {
  margin: 20px auto
}
.login-btn{
  background: #3692f9;
  color: #fff;
  width: 100%;
  margin-top: 40px;
  border-radius: 20px;
  line-height: 80px;
  height: 80px;
  font-size: 32px;
  border: 0;
}
h1{
  margin: 0;
  padding: 0;
}
</style>
